/**
 * e-Tesa — Dialog trimitere ofertă deviz pe email beneficiarului.
 * Extras din DevizTab.jsx (refactor Etapa 1A).
 *
 * Componenta este pur prezentațională: primește state-ul controllat de DevizTab
 * și emite acțiuni prin callback-uri.
 */

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Mail, Send, Loader2, AlertCircle } from "lucide-react";

export default function SendOfferDialog({
  open,
  onOpenChange,
  emailRecipient,
  setEmailRecipient,
  emailSubject,
  setEmailSubject,
  emailMessage,
  setEmailMessage,
  emailIncludeMaterials,
  setEmailIncludeMaterials,
  sendingEmail,
  beneficiarName,
  onSend,
  onCancel,
}) {
  return (
    <Dialog open={open} onOpenChange={(o) => !sendingEmail && onOpenChange(o)}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-indigo-700">
            <Mail className="w-5 h-5" />
            Trimite oferta pe email
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="email-recipient">Email destinatar *</Label>
            <Input
              id="email-recipient"
              type="email"
              placeholder="client@exemplu.ro"
              value={emailRecipient}
              onChange={(e) => setEmailRecipient(e.target.value)}
              disabled={sendingEmail}
              data-testid="email-recipient-input"
            />
            {beneficiarName && (
              <p className="text-xs text-slate-500 mt-1">Beneficiar: {beneficiarName}</p>
            )}
          </div>
          <div>
            <Label htmlFor="email-subject">Subiect</Label>
            <Input
              id="email-subject"
              value={emailSubject}
              onChange={(e) => setEmailSubject(e.target.value)}
              disabled={sendingEmail}
              data-testid="email-subject-input"
            />
          </div>
          <div>
            <Label htmlFor="email-message">Mesaj (opțional)</Label>
            <Textarea
              id="email-message"
              rows={5}
              placeholder="Mesaj personalizat pentru beneficiar..."
              value={emailMessage}
              onChange={(e) => setEmailMessage(e.target.value)}
              disabled={sendingEmail}
              data-testid="email-message-input"
            />
          </div>
          <label className="flex items-start gap-2 text-sm cursor-pointer p-2 rounded hover:bg-slate-50">
            <input
              type="checkbox"
              checked={emailIncludeMaterials}
              onChange={(e) => setEmailIncludeMaterials(e.target.checked)}
              disabled={sendingEmail}
              className="mt-0.5"
              data-testid="email-include-materials"
            />
            <span>
              <strong>Include detalierea materialelor</strong>
              <span className="block text-xs text-slate-500">
                Atașează PDF-ul extins cu toate materialele consumate (recomandat pentru oferte detaliate).
              </span>
            </span>
          </label>
          <div className="flex items-center gap-2 p-3 rounded-lg bg-amber-50 border border-amber-200 text-xs text-amber-800">
            <AlertCircle className="w-4 h-4 flex-shrink-0" />
            <span>
              PDF-ul va fi atașat automat la email. Trimiterea se face prin Resend cu numele firmei tale în câmpul <em>From</em>.
            </span>
          </div>
          <div className="flex justify-end gap-2 pt-2 border-t">
            <Button
              variant="outline"
              onClick={onCancel}
              disabled={sendingEmail}
              data-testid="email-cancel-btn"
            >
              Anulează
            </Button>
            <Button
              onClick={onSend}
              disabled={sendingEmail || !emailRecipient.trim()}
              className="bg-indigo-600 hover:bg-indigo-700 text-white"
              data-testid="email-send-btn"
            >
              {sendingEmail ? (
                <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Se trimite...</>
              ) : (
                <><Send className="w-4 h-4 mr-2" />Trimite oferta</>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
